import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExternTierarzt } from '../extern-tierarzt';

@Component({
    selector: 'kiene-extern-tierarzt-details-dialog',
    templateUrl: './extern-tierarzt-details-dialog.component.html',
    styleUrls: ['./extern-tierarzt-details-dialog.component.scss'],
})
export class ExternTierarztDetailsDialogComponent implements OnInit {
    externTierarzt: ExternTierarzt;
    editMode = false;

    constructor(
        public dialogRef: MatDialogRef<ExternTierarztDetailsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { externTierarzt?: ExternTierarzt; editMode?: boolean },
    ) {
        this.editMode = !!data?.editMode;
        if (data?.externTierarzt) {
            this.externTierarzt = data.externTierarzt;
        }
    }

    ngOnInit(): void {}
}
